export const lotStorageQueryKeys = {
  all: ['lot-storage'] as const,
  history: (lotId: string) => ['lot-storage', 'history', lotId] as const,
  contents: (locationId: string) => ['lot-storage', 'contents', locationId] as const,
  /** Under `all` on purpose: every mutation that invalidates `all` refreshes the card badges. */
  contentCounts: () => ['lot-storage', 'content-counts'] as const,
};
